<template functional>
  <div
    class="spinner-wrapper v-ctr h-ctr"
    :class="[data.class, data.staticClass, props.slim ? 'slim' : '']"
    :style="data.staticStyle"
    v-bind="data.attrs"
    aria-busy="true"
  >
    <span class="sr-only">{{ parent.$t('common.loading') }}</span>
    <div class="spinner"></div>
  </div>
</template>

<script>
export default {
  name: 'UiSpinner',

  props: {
    slim: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped>
.spinner-wrapper {
  height: 100%;
  padding-bottom: 48px;
}

.spinner-wrapper.slim {
  padding-bottom: 0;
}
</style>
